import type { ReactNode } from 'react';
import React from 'react';
import type { DeepReadonly } from '@itandi/itandi-bb-ui';
import { Flex, InputCheckBox } from '@itandi/itandi-bb-ui';
import { useFormContext } from 'react-hook-form';
import type {
  NotificationEdit,
  NotificationLineSetting
} from '~/models/Notification';
import Styles from '../NotificationModal.module.scss';
import type { LineUserAccount } from '~/models/LineUserAccount';

type Props = DeepReadonly<{
  lineUserAccounts: LineUserAccount[];
}>;
export const NotificationLineSettingsCheckBox: React.FC<Props> = ({
  lineUserAccounts
}: Props) => {
  const { watch, formState, setValue } = useFormContext<NotificationEdit>();
  const { errors } = formState;
  const notificationLineSettings = watch('notificationLineSettings');
  const onChangeCheckBox = React.useCallback(
    (
      e: React.ChangeEvent<HTMLInputElement>,
      lineUserAccountId: number
    ): void => {
      const { checked } = e.target;
      if (checked) {
        setValue(
          'notificationLineSettings',
          notificationLineSettings.concat({ lineUserAccountId })
        );
      } else {
        setValue(
          'notificationLineSettings',
          notificationLineSettings.filter(
            (notificationLineSetting) =>
              notificationLineSetting.lineUserAccountId !== lineUserAccountId
          )
        );
      }
    },
    [notificationLineSettings, setValue]
  );
  const findNotificationLineSetting = (
    lineUserAccountId: number
  ): DeepReadonly<NotificationLineSetting> | null =>
    notificationLineSettings.find(
      (notificationLineSetting) =>
        notificationLineSetting.lineUserAccountId === lineUserAccountId
    ) ?? null;

  return (
    <>
      <Flex direction="column" rowGap={2}>
        {lineUserAccounts.map(
          (lineUserAccount: LineUserAccount): ReactNode => (
            <InputCheckBox
              key={lineUserAccount.id}
              checked={!!findNotificationLineSetting(lineUserAccount.id)}
              isInvalid={errors.notificationLineSettings != null}
              label={lineUserAccount.name}
              onChange={(e: React.ChangeEvent<HTMLInputElement>): void =>
                onChangeCheckBox(e, lineUserAccount.id)
              }
            />
          )
        )}
      </Flex>
      {lineUserAccounts.length === 0 && (
        <div className={Styles.InvalidFeedback}>
          LINEアカウント設定から通知先を登録してください
        </div>
      )}
      {errors.notificationLineSettings != null && (
        <div className={Styles.InvalidFeedback}>
          {errors.notificationLineSettings.message}
        </div>
      )}
    </>
  );
};
